const getStockMutationMessage = (mutation, t) => {
    let displayName = "";
    let message = "";
    if (mutation.userId > 0) {
        displayName = mutation.displayName;
    } else {
        switch (mutation.userName) {
            case 'order':
                displayName = `${t('order')} ${mutation.displayName}`;
                break;
            case 'inbound':
                displayName = `${t('inbound')} ${mutation.displayName}`;
                break;
            default: 
                displayName = "";
        }
    }

    switch (mutation.type) {
        case "Inbound":
            message = t("stock_modified_by_inbound");

            if (mutation.remark?.indexOf(" - ") > -1) {
                message = `${message} (${mutation.remark.split(" - ")[1]})`;
            }

            break;
        case "Return": {
            message = t("stock_modified_by_return");

            // Prefer the linked return; older mutations only carry the reference in the remark
            const returnReference = mutation.return?.reference
                || (mutation.return?.order?.barcode ? `R${mutation.return.order.barcode}` : "")
                || (mutation.remark?.indexOf(" - ") > -1 ? mutation.remark.split(" - ")[1] : "");

            if (returnReference) {
                message = `${message} (${returnReference})`;
            }
            
            break;
        }
        case "Backorder":
            message = t("stock_modified_by_backorders");
            break;
        case "Manual":
            if (mutation.remark.toLowerCase() === "order cancelled") {
                message = t("stock_modified_by_cancellation");
            } else {
                message = mutation.remark;
            }
            break;
        default:
            message = t('available_stock_modified_by');
    }

    return `${message} ${displayName}`;
}

module.exports = {
    getStockMutationMessage
}
